import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'sl',
  months: [
    'januar',
    'februar',
    'marec',
    'april',
    'maj',
    'junij',
    'julij',
    'avgust',
    'september',
    'oktober',
    'november',
    'december',
  ],
  monthsShort: ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun.', 'jul.', 'avg.', 'sep.', 'okt.', 'nov.', 'dec.'],
  weekdays: ['nedelja', 'ponedeljek', 'torek', 'sreda', 'četrtek', 'petek', 'sobota'],
  weekdaysMin: ['n', 'p', 't', 's', 'č', 'p', 's'],
  weekdaysShort: ['ned.', 'pon.', 'tor.', 'sre.', 'čet.', 'pet.', 'sob.'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'D. M. YYYY',
    LL: 'D. MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D. MMMM',
    LLL: 'D. MMMM YYYY HH:mm',
    'LLL-Y': 'D. MMMM HH:mm',
    LLLL: 'dddd, D. MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd D. MMMM HH:mm',
    l: 'D. M. YYYY',
    'l-Y': 'D. M.',
    ll: 'D. MMM YYYY',
    'll-Y': 'D. MMM',
    lll: 'D. MMM YYYY h:mm A',
    'lll-Y': 'D. MMM h:mm A',
    llll: 'ddd, D. MMM YYYY h:mm A',
    'llll-Y': 'ddd, D. MMM h:mm A',
    'll-Y+w': 'ddd, D. MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D. MMMM YYYY HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'dop.', pm: 'pop.', AM: 'dop.', PM: 'pop.' },
  past: {
    y: { one: 'pred %s letom', two: 'pred %s letoma', few: 'pred %s leti', other: 'pred %s leti' },
    M: { one: 'pred %s mes.', two: 'pred %s mes.', few: 'pred %s mes.', other: 'pred %s mes.' },
    w: { one: 'pred %s ted.', two: 'pred %s ted.', few: 'pred %s ted.', other: 'pred %s ted.' },
    d: { one: 'pred %s dnevom', two: 'pred %s dnevoma', few: 'pred %s dnevi', other: 'pred %s dnevi' },
    h: { one: 'pred %s uro', two: 'pred %s urama', few: 'pred %s urami', other: 'pred %s urami' },
    m: { one: 'pred %s min.', two: 'pred %s min.', few: 'pred %s min.', other: 'pred %s min.' },
    s: { one: 'pred %s s', two: 'pred %s s', few: 'pred %s s', other: 'pred %s s' },
  },
  future: {
    y: { one: 'čez %s leto', two: 'čez %s leti', few: 'čez %s leta', other: 'čez %s let' },
    M: { one: 'čez %s mes.', two: 'čez %s mes.', few: 'čez %s mes.', other: 'čez %s mes.' },
    w: { one: 'čez %s ted.', two: 'čez %s ted.', few: 'čez %s ted.', other: 'čez %s ted.' },
    d: { one: 'čez %s dan', two: 'čez %s dneva', few: 'čez %s dni', other: 'čez %s dni' },
    h: { one: 'čez %s uro', two: 'čez %s uri', few: 'čez %s ure', other: 'čez %s ur' },
    m: { one: 'čez %s min.', two: 'čez %s min.', few: 'čez %s min.', other: 'čez %s min.' },
    s: { one: 'čez %s s', two: 'čez %s s', few: 'čez %s s', other: 'čez %s s' },
  },
  abbr: {
    y: { one: '%s l', two: '%s l', few: '%s l', other: '%s l' },
    M: { one: '%s m', two: '%s m', few: '%s m', other: '%s m' },
    w: { one: '%s t', two: '%s t', few: '%s t', other: '%s t' },
    d: { one: '%s d', two: '%s d', few: '%s d', other: '%s d' },
    h: { one: '%s h', two: '%s h', few: '%s h', other: '%s h' },
    m: { one: '%s min', two: '%s min', few: '%s min', other: '%s min' },
    s: { one: '%s sek.', two: '%s sek.', few: '%s sek.', other: '%s sek.' },
  },
  justNow: 'zdaj',
  yesterday: 'včeraj',
  today: 'danes',
  tomorrow: 'jutri',
  weekStart: 1,
};
const localeName: LocaleName = 'sl';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'dop.' : 'dop.';
    } else {
      return isLowerCase ? 'pop.' : 'pop.';
    }
  },
};
